import { MainRoute } from '../../../app/package/base/router/router';
import type { IncentivePageView } from '../types';

export function getPathNavigateToIncentiveInternalPage(view: IncentivePageView, id = ''): string {
  return `${MainRoute.INCENTIVE}/${view}/${id}`;
}

export function getPathForHTMLLink(view: IncentivePageView, id = '', includeLangPrefix = true): string {
  const langPrefix = includeLangPrefix ? `/${window.$app.appConfig.lang}` : '';
  const link = getPathNavigateToIncentiveInternalPage(view, id);
  return `${langPrefix}/${link}`;
}
